import MusicHeader from './Header/MusicHeader';
import MusicFooter from './Footer/MusicFooter';

import styles from '../css/App.module.css';

const Layout = ({ children, fullWidth }) => {
  return (
    <div>
      <div className={styles.appContainer}><MusicHeader /></div>
      <div className={fullWidth ? "" : styles.appContainer}>{children}</div>
      <div className={styles.appContainer}><MusicFooter /></div>
    </div>
  )
}

export default Layout;